import { Select } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/store';
import { getCurrentDivision, setCurrentOption } from 'entities/divisions/model';
import { selectors } from 'entities/viewer/model/me';
import React, { useEffect, useState } from 'react';

export type TabItem = { label: string; value: string; type: TabKeys };

export enum TabKeys {
  DEPUTY = 'Deputy',
  SUPERVISOR = 'Supervisor',
  ACTING = 'Acting',
  TIMEKEEPER = 'Timekeeper',
}

const Divisions = () => {
  const [options, setOptions] = useState<TabItem[]>([]);
  const dispatch = useAppDispatch();
  const profile = useAppSelector(selectors.selectViewerProfile);
  const currentDivision = useAppSelector(getCurrentDivision);

  useEffect(() => {
    const preparedOptions: TabItem[] = [];
    if (profile?.dublicate?.isSupervisor) {
      preparedOptions.push({
        label: profile.division?.name || '',
        value: profile.division?.id || '',
        type: TabKeys.SUPERVISOR,
      });
    }
    if (profile?.dublicate?.isActing) {
      for (const division of profile.dublicate?.actingDivisions || []) {
        preparedOptions.push({
          label: division.name || '',
          value: division.id || '',
          type: TabKeys.ACTING,
        });
      }
    }
    if (profile?.dublicate?.isDeputy) {
      for (const division of profile.dublicate?.deputyI || []) {
        preparedOptions.push({
          label: division.divisionName || '',
          value: division.divisionId || '',
          type: TabKeys.DEPUTY,
        });
      }
    }
    if (profile?.dublicate?.isTimekeeper) {
      preparedOptions.push({
        label: profile.division?.name || '',
        value: profile.division?.id || '',
        type: TabKeys.TIMEKEEPER,
      });
    }
    setOptions(preparedOptions);

    dispatch(setCurrentOption(preparedOptions[0]));
  }, [profile]);

  const selectHandler = (id: string) => {
    const selectedOption = options.find(elem => elem.value === id);
    if (selectedOption) {
      dispatch(setCurrentOption(selectedOption));
    }
  };

  return (
    <>
      {options?.length > 1 && (
        <Select placeholder="Выберите из списка" onSelect={selectHandler} value={currentDivision.currentOption?.value}>
          {options.map(({ label, type, value }) => (
            <Select.Option key={value} value={value}>
              {label}
            </Select.Option>
          ))}
        </Select>
      )}
    </>
  );
};

export default Divisions;
